import { Component, OnInit, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatRadioChange, MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

export interface DialogData {
  notification: boolean;
  noDeleteReason: boolean;
}
@Component({
  selector: 'app-delete-ride',
  templateUrl: './delete-ride.component.html',
  styleUrls: ['./delete-ride.component.scss'],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatRadioGroup,
    MatRadioButton,
    MatFormField,
    MatLabel,
    MatInput,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ],
})
export class DeleteRideComponent implements OnInit {
  deleteForm: UntypedFormGroup = this.fb.group({
    deleteReason: ['', [Validators.required]],
  });
  radioOptions = [
    'Geannuleerd door passagier',
    'Geannuleerd door organisatie',
    'Geen voertuig/chauffeur beschikbaar',
    'Anders:',
  ];
  defaultOption = 'Anders:';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private fb: UntypedFormBuilder,
  ) {}

  ngOnInit() {
    if (this.data.noDeleteReason) {
      this.deleteForm.controls.deleteReason.removeValidators(Validators.required);
      this.deleteForm.controls.deleteReason.updateValueAndValidity();
    }
  }

  checkState(el: MatRadioChange) {
    if (el.value == 'Anders:') {
      this.deleteForm.controls.deleteReason.setValue('');
      this.deleteForm.controls.deleteReason.enable();
    } else {
      this.deleteForm.controls.deleteReason.setValue(el.value);
      this.deleteForm.controls.deleteReason.disable();
    }
  }
}
